import axios from 'axios';

export const create = (requestParams, formData, callback) => {
  let promise = axios({
    method: 'post',
    url: Routes.abstract_entity_folder_check_list_requirements_path({ ... {... requestParams }, format: 'json', _options: true }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    }
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
}
